const Timeline = () => {
    const timelineItems = [
        {
            date: '2026 Juni',
            title: 'Korsika',
            description: 'Van and Beaches',
            link: '/korsika'
        },
        {
            date: '2025/26 New Year',
            title: 'Schweden',
            description: 'New Year im Schnee',
            link: '/schweden2026'
        },
        {
            date: '2025 September',
            title: 'Thailand',
            description: 'Chiang Mai, Koh Tao und Koh Samui',
            link: '/thailand2025'
        },
        {
            date: '2025 Juni',
            title: 'Schottland',
            description: 'Scottisch Highlands und NC500',
            link: '/schottland'
        },
        {
            date: '2025 Januar',
            title: 'Schweden',
            description: 'Schneelandschaft Sandsjögarden',
            link: '/schweden'
        },
        {
            date: '2024 September',
            title: 'Norwegen',
            description: 'Roadtrip via Schweden nach Norwegen',
            link: '/norwegen'
        },
        {
            date: '2024 März',
            title: 'Zandvoort',
            description: 'Amsterdam, Tulpen und Meer',
            link: '/zandvoort'
        },
        {
            date: '2024 Januar/Februar',
            title: 'Sri Lanka',
            description: 'Kultur hautnah.',
            link: '/srilanka'
        },
        {
            date: '2023 Oktober',
            title: 'Thailand',
            description: 'Stadt und Insel.',
            link: '/thailand'
        },
        {
            date: '2023 September',
            title: 'Split',
            description: 'Weekendtrip ans Meer',
            link: '/split'
        },
        {
            date: '2023 Mai',
            title: 'Mauritius und Rodrigues',
            description: 'Rundreise und Inselleben.',
            link: '/mauritius'
        },
        {
            date: '2022 Oktober',
            title: 'Entdeckungsreise Belize',
            description: 'Dschungel, Stadt und Landschaft.',
            link: '/belize'
        }
    ];

    return (
        <section className="travel-timeline">
            <h2 className="timeline-headline">Meine Reisen</h2>

            <div className="timeline-line">
                {timelineItems.map((item, index) => (
                    <div className="timeline-entry" key={index}>
                        <div className="timeline-marker"></div>

                        <div className="timeline-content">
                            <span className="timeline-date">
                                {item.date}
                            </span>

                            <h3>{item.title}</h3>

                            <p>{item.description}</p>

                            <a href={item.link}>
                                Blog ansehen →
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Timeline;